import { ApplicationConfig, APP_INITIALIZER, provideBrowserGlobalErrorListeners } from '@angular/core';
import { provideHttpClient, withInterceptors } from '@angular/common/http';
import { provideRouter } from '@angular/router';
import { provideOAuthClient } from 'angular-oauth2-oidc';

import { routes } from './app.routes';
import { ThemeService } from './core/theme/theme.service';
import { authInterceptor } from './features/auth/interceptors/auth.interceptor';
import { auditoriaInterceptor } from './core/auditoria/auditoria.interceptor';
import { AuditoriaService } from './core/auditoria/auditoria.service';
import { AuthService } from './features/auth/services/auth.service';

function initAuth(authService: AuthService): () => Promise<void> {
  return async () => {
    try {
      await authService.init();
    } catch {
      // No bloquear el bootstrap: login/callback resuelven el error con UX explícita.
    }
  };
}

function initTheme(themeService: ThemeService): () => void {
  return () => themeService.init();
}

function initAuditoria(auditoriaService: AuditoriaService): () => void {
  return () => auditoriaService.init();
}

export const appConfig: ApplicationConfig = {
  providers: [
    provideBrowserGlobalErrorListeners(),
    provideOAuthClient(),
    provideHttpClient(withInterceptors([authInterceptor, auditoriaInterceptor])),
    provideRouter(routes),
    {
      provide: APP_INITIALIZER,
      useFactory: initTheme,
      deps: [ThemeService],
      multi: true,
    },
    {
      provide: APP_INITIALIZER,
      useFactory: initAuth,
      deps: [AuthService],
      multi: true,
    },
    {
      provide: APP_INITIALIZER,
      useFactory: initAuditoria,
      deps: [AuditoriaService],
      multi: true,
    },
  ],
};
